import { apiClient } from './client';

export interface FollowUser {
  id: string;
  username: string;
  displayName: string;
  avatarUrl: string | null;
  nickIcon: string | null;
  nickColor: string | null;
  followerCount?: number;
}

export const followApi = {
  async follow(userId: string) {
    const r = await apiClient.post(`/api/follow/${userId}`);
    return r.data as { followed: boolean; alreadyFollowed: boolean };
  },
  async unfollow(userId: string) {
    const r = await apiClient.delete(`/api/follow/${userId}`);
    return r.data as { followed: boolean; removed: boolean };
  },
  async status(userId: string) {
    const r = await apiClient.get(`/api/follow/${userId}/status`);
    return r.data.following as boolean;
  },
  async followers(userId: string, cursor?: string) {
    const r = await apiClient.get(`/api/follow/${userId}/followers`, { params: { cursor } });
    return r.data as { items: FollowUser[]; nextCursor: string | null };
  },
  async following(userId: string, cursor?: string) {
    const r = await apiClient.get(`/api/follow/${userId}/following`, { params: { cursor } });
    return r.data as { items: FollowUser[]; nextCursor: string | null };
  },
};
